import { __assign } from "tslib";
import React from 'react';
// @ts-ignore
import { ProGallery } from 'pro-gallery';
// @ts-ignore
import { getResizeMediaUrl } from '@wix/photography-client-lib';
import { LayoutFixer } from '@wix/pro-gallery-layout-fixer';
import { flattenObject } from 'pro-gallery-lib';
import { CustomImageRenderer, } from '@wix/photography-shared-ui';
export var ProGalleryWrapper = function (props) {
    var container = props.container;
    //TODO - Add this to props...
    var staticMediaUrls = props.staticMediaUrls;
    var items = props.items;
    var eventsListener = props.eventsListener;
    var createMediaUrl = getResizeMediaUrl({ staticMediaUrls: staticMediaUrls, imageToken: undefined, useOptimizedImageFormat: props.options.useOptimizedImageFormat, isPrerenderMode: props.isPrerenderMode });
    var customComponents = {
        customNavArrowsRenderer: props.customNavArrowsRenderer,
        customInfoRenderer: props.customInfoRenderer,
        customImageRenderer: function (props) { return React.createElement(CustomImageRenderer, __assign({}, props)); }
    };
    return (React.createElement("div", { className: 'pro-gallery-fullscreen-slider-wrapper' },
        React.createElement(LayoutFixer, { id: 'pro-gallery-fullscreen-wrapper', items: items, options: flattenObject(props.options), isPrerenderMode: props.isPrerenderMode, containerPostProcess: props.containerPostProcess, measureContainerId: 'pro-fullscreen-wrapper' }),
        React.createElement(ProGallery, { totalItemsCount: props.totalItemsCount, items: items, isPrerenderMode: props.isPrerenderMode, container: container, key: 'pro-gallery-fullscreen-wrapper', id: 'pro-gallery-fullscreen-wrapper', options: props.options, settings: props.settings, eventsListener: eventsListener, activeIndex: props.activeIndex, customComponents: customComponents, createMediaUrl: createMediaUrl, virtualizationSettings: { enabled: true }, experimentalFeatures: {} })));
};
//# sourceMappingURL=proGalleryWrapper.js.map